import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GradientButton from './GradientButton';
import GradientText from './GradientText';

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const videoRef = useRef(null);

  useEffect(() => {
    // Play video
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error(t('errors.videoPlayback'), error);
      });
    }
  }, [t]);

  const handleVideoError = (e) => {
    console.error(t('errors.video'), e.target.error);
  };

  return (
    <div className="relative bg-background text-primary overflow-hidden min-h-screen sm:min-h-[700px] lg:min-h-[800px]">
      {/* Video Background */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        loop
        muted
        playsInline
        autoPlay
        preload="metadata"
        onError={handleVideoError}
      >
        <source src="/videos/herovideobroccoli.mp4" type="video/mp4" />
        {t('errors.videoUnsupported')}
      </video>

      {/* Gradient Overlay - Smooth black gradient for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-32">
        <div className="flex flex-col items-center justify-center text-center max-w-5xl w-full">
          <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold mb-4 sm:mb-6 md:mb-8 w-full leading-tight px-2">
            {(() => {
              const currentLang = i18n.language;

              if (currentLang === 'it') {
                return (
                  <span className="inline-flex flex-wrap items-baseline justify-center gap-x-2 sm:gap-x-3 gap-y-1 sm:gap-y-2">
                    <span className="break-words">Smetti di Contare Calorie,</span>
                    <span className="break-words">Inizia a Contare</span>
                    <GradientText
                      colors={['#9cff1e', '#ffde59', '#0cc0df', '#9cff1e', '#ffde59']}
                      animationSpeed={5}
                      showBorder={false}
                    >
                      i Risultati
                    </GradientText>
                  </span>
                );
              } else {
                return (
                  <span className="inline-flex flex-wrap items-baseline justify-center gap-x-2 sm:gap-x-3 gap-y-1 sm:gap-y-2">
                    <span className="break-words">Stop Counting Calories,</span>
                    <span className="break-words">Start Counting</span>
                    <GradientText
                      colors={['#9cff1e', '#ffde59', '#0cc0df', '#9cff1e', '#ffde59']}
                      animationSpeed={5}
                      showBorder={false}
                    >
                      Results
                    </GradientText>
                  </span>
                );
              }
            })()}
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 md:mb-10 max-w-3xl mx-auto animate-fade-in-up text-gray-100 px-2">
            {t('hero.description')}
          </p>

          {/* Action Buttons */}
          <div className="w-full max-w-lg px-2">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center animate-fade-in">
              <GradientButton
                variant="primary"
                href="https://forms.gle/b73YhN5WxGSTZn618"
                className="w-full sm:w-auto"
                trackingEvent="click_dicci_la_tua"
                trackingLabel="hero_section"
              >
                {t('common.shareOpinion')}
              </GradientButton>
              <GradientButton
                variant="secondary"
                href="https://drive.google.com/file/d/1QJEeyfEdiYeDN15PYUfwrHjOSWd_MdAA/view?usp=sharing"
                className="w-full sm:w-auto"
                trackingEvent="click_scopri_di_piu"
                trackingLabel="hero_section"
              >
                {t('common.brochure')}
              </GradientButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
